/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;




/*****************
 ** WEBPACK FOOTER
 ** ./~/intl-format-cache/index.js
 ** module id = 1466
 ** module chunks = 0
 **/